// © Microsoft Corporation. All rights reserved.

import { TypeRampItem, typeRamp } from "@microsoft/fast-components-styles-msft";

import { TypographySize } from "@microsoft/fast-components-react-base";
import { memoize } from "lodash-es";

/**
 * Gets the style props to add, given a typography size.
 * @param size The typography size.
 * @returns The CSS properties to apply to the element, or null if no size was given.
 */
export const getStyleFromTypographySize = memoize((size: TypographySize): React.CSSProperties => {
    if (!size) {
        return null;
    }

    const typeRampItem: TypeRampItem = typeRamp["t" + size];
    return {
        fontSize: typeRampItem.fontSize + "px",
        lineHeight: typeRampItem.lineHeight + "px"
    };
});